module.exports = __webpack_public_path__ + "images/assets/4ed1e00befeabab26e58ece5442826aa.svg";